export const removeExtraSpaces = (value) => value.trim().replace(/\s+/g, " ");
export const randomHexString = (length = 32) => [...Array(length)].map(() => Math.floor(Math.random() * 16).toString(16)).join("");
